import { render, staticRenderFns } from "./IcBookmarkOn.vue?vue&type=template&id=f051b0dc&scoped=true"
import script from "./IcBookmarkOn.vue?vue&type=script&lang=js"
export * from "./IcBookmarkOn.vue?vue&type=script&lang=js"
import style0 from "./IcBookmarkOn.vue?vue&type=style&index=0&id=f051b0dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f051b0dc",
  null
  
)

export default component.exports